import Vue from 'vue'
import Router from 'vue-router'
import layout from './views/layout/layout.vue'

// 网络请求框架
import axios from 'axios'
axios.defaults.withCredentials = true //让ajax携带cookie
Vue.prototype.$http = axios // 这样设置就可以在组件内用 this.$http 使用axios了

Vue.use(Router)

function getTitle() { //获取标题
    var arr = null;
    var reg = new RegExp("(^| )ganWangTitle=([^;]*)(;|$)");
    var arr = document.cookie.match(reg);
    if (arr) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}
export default new Router({
    // mode: 'history',
    routes: [{
            path: '/wenDang',
            name: 'wenDang',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/wenDang.vue')
        },
        {
            path: '/gsjianjie',
            name: 'gsjianjie',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about/gsjianjie.vue')
        },
        {
            path: '/serviceSupport',
            name: 'serviceSupport',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/serviceSupport.vue')
        },
        {
            path: '/templateList',
            name: 'templateList',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/public/templateList.vue')
        },
        {
            path: '/templateDetail',
            name: 'templateDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/public/templateDetail.vue')
        },
        {
            path: '/',
            name: 'home',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/index.vue')
        },
        {
            path: '/index',
            name: 'index',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/index.vue')
        },
        {
            path: '/about',
            name: 'about',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about.vue')
        },{
            path: '/about/related',
            name: 'aboutRelated',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/related.vue')
        },
        {
            path: '/about/jianjie',
            name: 'aboutJianjie',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about/jianjie.vue')
        },
        {
            path: '/about/wenhua',
            name: 'aboutWenhua',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about/wenhua.vue')
        },
        {
            path: '/case/detail',
            name: 'caseDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/case/detail.vue')
        },
        {
            path: '/about/chengnuo',
            name: 'aboutChengnuo',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about/chengnuo.vue')
        },
        {
            path: '/about/linian',
            name: 'aboutLinian',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/about/linian.vue')
        },
        {
            path: '/news',
            name: 'news',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/news.vue')
        },
        {
            path: '/news/detail',
            name: 'newsDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/news/detail.vue')
        },
        {
            path: '/chanpin',
            name: 'chanpin',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/chanpin.vue')
        },
        {
            path: '/jishu',
            name: 'jishu',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu.vue')
        },
        {
            path: '/jishu/zl',
            name: 'jishuZl',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/zl.vue')
        },
        {
            path: '/jishu/detail',
            name: 'jishuDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/detail.vue')
        },
        {
            path: '/jishu/wenti',
            name: 'jishuWenti',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/wenti.vue')
        },
        {
            path: '/jishu/chanpin',
            name: 'jishuChanpin',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/chanpin.vue')
        },
        {
            path: '/jishu/xia',
            name: 'jishuXia',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/xia.vue')
        },
        {
            path: '/jishu/zaixian',
            name: 'jishuZaixian',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/zaixian.vue')
        },
        {
            path: '/jishu/zhinan',
            name: 'jishuZhinan',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/jishu/zhinan.vue')
        },
        {
            path: '/focus',
            name: 'focus',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/focus.vue')
        },
        {
            path: '/focus/detail',
            name: 'focusDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/focus/detail.vue')
        },
        {
            path: '/focus/dhrj',
            name: 'focusDhrj',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/focus/dhrj.vue')
        },
        {
            path: '/focus/jmqd',
            name: 'focusJmqd',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/focus/jmqd.vue')
        },
        {
            path: '/focus/kzxt',
            name: 'focusKzxt',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/focus/kzxt.vue')
        },
        {
            path: '/case',
            name: 'case',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/case.vue')
        },
        {
            path: '/search',
            name: 'search',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/search.vue')
        },
        {
            path: '/lianxi',
            name: 'lianxi',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/lianxi.vue')
        },
        {
            path: '/lianxi/ditu',
            name: 'lianxiDitu',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/lianxi/ditu.vue')
        },
        {
            path: '/chanpin/detail',
            name: 'chanpinDetail',
            meta: {
                title: getTitle()
            },
            component: () =>
                import ('./views/pages/front/chanpin/detail.vue')
        },
        {
            path: '/backLogin',
            name: 'backLogin',
            meta: {
                title: getTitle()
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ('./views/pages/back/Login.vue')
        },
        {
            path: '/back',
            name: 'back',
            meta: {
                title: getTitle()
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ('./views/pages/back/Login.vue')
        },
        {
            path: "/back",
            meta: {
                title: getTitle()
            },
            component: layout,
            children: [{
                    path: "/back/userlist",
                    name: "userlist",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/user/list.vue")
                },
                {
                    path: "/back/classify",
                    name: "classify",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/classify.vue")
                },
                {
                    path: "/back/content",
                    name: "content",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/content.vue")
                },
                {
                    path: "/back/contactUs",
                    name: "contactUs",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/contactUs.vue")
                },
                {
                    path: "/back/languageConfig",
                    name: "languageConfig",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/languageConfig.vue")
                },
                {
                    path: "/back/contactusConfig",
                    name: "contactusConfig",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/contactusConfig.vue")
                },
                {
                    path: "/back/caseType",
                    name: "caseType",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/caseType.vue")
                },
                {
                    path: "/back/qiYeYanGe",
                    name: "qiYeYanGe",
                    meta: {
                        requireAuth: true,
                        title: getTitle()
                    },
                    component: () =>
                        import ("./views/pages/back/qiYeYanGe.vue")
                }
            ]
        },
        {
            path: '*',
            name: '404',
            redirect: () => {
                return '' //"/admin/"
            }
        },
    ]
})